/**
 * Meta Commerce custom code snippets
 */
(function(){

    /**
     * Product description "Read More"
     */
    $('.product-read-more').on('click', function() {
        let pDesc = $('.product-description').get(0);
        if ($(pDesc).css('max-height') =='none'){
            $(pDesc).css('max-height','600px');
            $(this).text('Read More');
        } else {
            $(pDesc).css('max-height','none');
            $(this).text('Read Less');
        }
    });

    if ($('.product-description').height() < 600) {
        $('.product-read-more').toggle(false);
    }

    /**
     * Handle ?review= param: jumps to write a review
     */
    if (getQueryVariable('review')) {
        let i = 0;
        let jumpToReviews = setInterval(function() {  // Iterating

            let reviewsButton = $('#judgeme_product_reviews .jdgm-write-rev-link');
            if (reviewsButton.length) {
                let scrollTo =  $(reviewsButton).offset().top;
                if (scrollTo) {  // Not zero
                    scrollTo -= 250;  // Not clear to me why this is sometimes necessary
                    $('html,body').animate({scrollTop: scrollTo},'slow');
                    reviewsButton[0].click();
                    clearInterval(jumpToReviews);
                }
            }
            if (i++ > 50) { // After 5 seconds, something went wrong
                clearInterval(jumpToReviews);
            }
        },100);
    }

    /**
     * ?video param: Jump to and open targeted video
     */
    let target_video = getQueryVariable('video');
    if (target_video) {
        setTimeout(function() {
            // Jump focus down to videos widget
            let video_elem = $('#product-videos');
            $('html,body').animate({scrollTop: video_elem.offset().top},'slow');
            // ?video=1 will highlight only / first: To highlight a specific one pass by id or idx
            if (target_video > 1) {
                if (target_video < 25) {
                    // Allow accessing the Nth vide by ?video=2, ?video=3 etc
                    let multiple_videos = $(video_elem).find('div.product-video');
                    if (multiple_videos.length >= target_video) {
                        target_video = $(multiple_videos[target_video - 1]).data('video-id')
                    }
                }
                if (target_video && target_video > 25) {
                    $('a[data-thumbnail-id="' + target_video + '"').click();
                }
            }
        }, 400);
    }

    /**
     * This is for the ZMan holiday promo 2019.
     * MCE is mail chimp: when their success form would be displayed (on form success)
     * Hide theirs and show ours.
     */
    $('#mce-success-response').on('DOMSubtreeModified', function() {
        $('#mce-success-response').hide();
        $('#mc_embed_signup').hide();
        $('#mce-success-response-custom').show();
    });

    /**
     * This injects "Write a Review" button into customerHub orders
     * Note that it uses the also-homegrown ?review link
     */
    if ($('div#CustomerHubApp').length) {
        $('.chProductLink').each(function() {
            let reviewhref = $(this).attr('href') + '?review=1';
            let button = '<a href="' + reviewhref + '" class="chProductLink"><button class="chButton">Write a Review</button>';
            $(this).before(button);
        });
    }


    /**
     * Grid and Explosive PDPs: link that "jumps" to where you can find the products
     */
    $('.jump-to').on('click', function() {
        let target_container = false;
        if ($('.explosive-variants-container').length) {
            target_container = $('.explosive-variants-container')[0];
        }
        if ($('#grid-product-grid').length) {
            target_container = $('#grid-product-grid')[0];
        }
        if (target_container) {
            $('html,body').animate({scrollTop: $(target_container).offset().top},'slow');
        }
    });

    if ($('nav.jump-to').length) {
        let navelem = $('nav.jump-to')[0];
        if (navelem.getBoundingClientRect().top > 600) {
            $('html,body').animate({scrollTop: $(navelem).offset().top - 50},1200);
        }
    }
})();

 function refreshZoom() {
    $('.image-zoom').each(function() {
        $(this).parent().trigger('zoom.destroy');
        $(this).parent().zoom({
                url:$(this).attr('data-zoom'),
                on: 'click',
                touch: false,
                onZoomIn: function() {
                    $(this).toggleClass('move-cursor');
                },
                onZoomOut: function() {
                    $(this).toggleClass('move-cursor');
                }
            }
        );
    });
};

$(document).ready(function(){
    if ($('.explosive-variant').length == 0) {
        refreshZoom();
    }
    // Set all videos except first one inactive. This is done on ready because other js fills only visible video blocks
    // (There may be a brief flash all videos)
    $('.product-video:not(:first-child)').addClass('inactive');

    $('.thumbnail a').click(function() {
        let selected_video = $(this).data('thumbnail-id');
        $('.product-video').addClass('inactive');
        $('.product-video[data-video-id=' + selected_video +']').removeClass('inactive');
        $('.thumbnail').removeClass('active');
        $(this).parent().addClass('active');
    });

    $('#product-video-link a').on('click', function(e) {
        e.preventDefault();
        let target_container = $('#product-videos-mobile')[0];
        if (target_container) {
            $('html,body').animate({scrollTop: $(target_container).offset().top},'slow');
        }
    });

});

$(".sliding-link").click(function(e) {
    e.preventDefault();
    var aid = $(this).attr("href");
    $('html,body').animate({scrollTop: $(aid).offset().top},'slow');
});

function getQueryVariable(variable)
{
    var query = window.location.search.substring(1);
    var vars = query.split("&");
    for (var i=0;i<vars.length;i++) {
        var pair = vars[i].split("=");
        if(pair[0] == variable){return pair[1];}
    }
    return(false);
}

/**
 * Updates the header's cart widget to show users the quantity of items in their cart.
 * @param {*} qty int
 */
function addToCartHeader(qty) {
    let currentQty = parseInt($('.site-header-cart--count').data('header-cart-count')) || 0;
    let newQty = currentQty + parseInt(qty)
    $('.site-header-cart--count')
        .data('header-cart-count', newQty)
        .attr('data-header-cart-count', newQty);
    if (newQty > 0) {
        $('.site-header-cart--count').addClass('visible');
    }
};

jQuery(document).ready(function($) {

    /* fix iOS touchmove issue */
    ;
    (function() {
        let touchingCarousel = false
        let startXCoordinate

        document.body.addEventListener('touchstart', e => {
            if (e.target.closest('.flickity-slider')) {
                touchingCarousel = true
            } else {
                touchingCarousel = false
                return
            }
            startXCoordinate = e.touches[0].pageX
        })

        document.body.addEventListener('touchmove', e => {
            if (
                !touchingCarousel ||
                !e.cancelable ||
                Math.abs(e.touches[0].pageX - startXCoordinate) < 8
            ) return
            e.preventDefault()
            e.stopPropagation()
        }, {
            passive: false
        })
    }())

    /* prevent resize in flickity if still animating
    var resize = Flickity.prototype.resize;
    Flickity.prototype.resize = function() {
        if (!this.isAnimating) {
            resize.call(this);
        }
    };
    */
});